import React from 'react';
import { createSlice } from '@reduxjs/toolkit'

const initialMiscState = {
  data: {
    courseCount: 0,
  },
};

const miscSlice = createSlice({
  name: 'miscData',
  initialState: initialMiscState,
  reducers: {
    setCourseCount: (state, action) => {
      state.data.courseCount = action.payload;
    },
    setMiscData: (state, action) => {
      state.data = { ...state.data, ...action.payload };
    }
  },
});

export const { setMiscData, setCourseCount } = miscSlice.actions;
export const miscDataReducer = miscSlice.reducer;